<template>
    <academic>
        <card-header :title="'Course Year: '+courseyear.title+' - '+courseyear.course.title" />
        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Edit Course Semester</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-3 sm:col-span-3">
                            <!-- <breeze-label :value="'Semester'"/>
                            <select-list required v-model="form.semester" :options="semesters" :label="['title']" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.duration:''" /> -->
                             <FormMultiselect
                                required
                                label="Semester"
                                :options="semesters"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                v-model="form.semester"
                                :placeholder="'Select Semester Type'"
                                :error="form.errors.semester"
                                />
                        </div>
                        <div class="col-span-3 sm:col-span-3">
                            <!-- <breeze-label :value="'Subject'"/>
                            <select-list required v-model="form.subject" :options="subjects" :label="['title']" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.course:''" /> -->
                              <FormMultiselect
                                required
                                label="Subject"
                                :options="subjects"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                v-model="form.subject"
                                :placeholder="'Select Subject'"
                                :error="form.errors.course"
                                />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status" :checked="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>
                    </div>
                    <button-link :href="route('academic.courseyear.list')" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception />
                </form>
            </div>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import InputCheckbox from '@/Components/InputCheckbox'
    import BreezeInputError from '@/Components/InputError'
    import ButtonLink from '@/Components/ButtonLink'
    import SelectList from '@/Components/SelectList'
    import Exception from '@/Components/Exception'
    import { useForm } from '@inertiajs/inertia-vue3'
    import Loading from '@/Components/Loading'
    import CardHeader from '@/Components/CardHeader'
    import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

    export default {
        components: {
            FormMultiselect,
            Academic,
            BreezeTable,
            ButtonLink,
            BreezeInput,
            BreezeCheckbox,
            BreezeLabel,
            BreezeInputError,
            BreezeButton,
            Exception,
            InputCheckbox,
            Loading,
            SelectList,
            CardHeader
        },
        props:['coursesemester','semesters','subjects','courseyear'],
        data(){
            return{
                form: useForm({
                    '_method':'PUT',
                    subject: this.coursesemester.subject,
                    semester: this.coursesemester.semester,
                    status: this.coursesemester.status,
                }),
            }
        },
        methods: {
            submitForm() {
                this.form.post(route('academic.courseyear.semester.update',this.coursesemester.id),{
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                });
            },
        }
    }
</script>
